// Module
var code = `<div class="copy-trading-panel">
    <div class="header-container">
        <div class="column-header from-account">
            <div class="header-background"></div>
            <span class="header-text">{{fromAccountText}}</span>
        </div>
        <div class="column-header to-accounts">
            <div class="header-background"></div>
            <span class="header-text">{{toAccountsText}}</span>
        </div>
    </div>

    {{#each accounts:i}}
    <div class="account-row">
        <div class="accountMenuItem">
            <div class="accountMenuItem-container-mode {{#if ~/addtype}}addtype{{/if}}">
                <div class="accountMenuItem-mode {{@this.getAccountModeText(accounts[i])}}-accItem">
                    {{@this.getAccountModeText(accounts[i])}}
                </div>
                <div
                    class="accountMenuItem-type {{#if !~/addtype}}no-addtype{{/if}} {{#if @this.getIsEmptyType(accounts[i])}}empty-type{{/if}}"
                    style="background-color: {{@this.getInstrumentColor(accounts[i])}};"
                >
                    {{@this.getInstrumentTypeName(accounts[i])}}
                </div>
            </div>
            <div class="accountMenuItem-name">{{@this.getAccountName(accounts[i])}}</div>
        </div>

        <div class="combobox-container">
            <accountsComboBox
                isMultiSelect="{{true}}"
                excludeAccounts="{{excludedAccounts[i]}}"
                selectedItems="{{selectedItems[i]}}"
                enabled="{{!isStarted[i]}}"
                ignoreForceLinkingByAccount="{{true}}"
                onlyOwnAccounts="{{true}}"
            />
        </div>

        <!-- Start/Stop btn area -->
        <div class="button-container">
            <terceraButton
                terceraButtonStyle="js-button-copy-trading {{isStarted[i] ? 'stop' : 'start'}}"
                text="{{isStarted[i] ? btnStopText : btnStartText}}"
                enabled="{{isStarted[i] || selectedItems[i].length > 0}}"
                on-btnClick="@this.onStartOrStopButtonClick(i)"
                tooltip="{{@this.getBtnTooltip(i)}}"
            />
        </div>
    </div>
    {{/each}}
</div>
`;
// Exports
export default code;